import { useEffect } from 'react';
import { useCodexStore } from '@/stores/codexStore';
import { isTauriRuntime } from './tauriBridge';
import { mirrorNow } from './mirror';

const MIRROR_DEBOUNCE_MS = 2000;

/**
 * canon 미러 동기화(AI-native K0, K5-f 개정) — Dexie 정본 변경을 idle 2s 후 mirrorNow로.
 * 실제 쓰기·해시 스킵·실패 노출·재시도는 mirror.ts 단일 소유(전송 전 flush와 경로 공유).
 * AppShell에서 앱 수명 동안 1회 마운트.
 */
export function useCanonMirror() {
  const project = useCodexStore((s) => s.project);
  const entities = useCodexStore((s) => s.entities);
  const links = useCodexStore((s) => s.links);

  useEffect(() => {
    if (!isTauriRuntime() || !project) return;
    const t = setTimeout(() => {
      void mirrorNow();
    }, MIRROR_DEBOUNCE_MS);
    return () => clearTimeout(t);
  }, [project, entities, links]);
}
